export var TimezoneSelectionDataHooks;
(function (TimezoneSelectionDataHooks) {
    TimezoneSelectionDataHooks["TIMEZONE_SELECTION"] = "timezone-selection";
    TimezoneSelectionDataHooks["TIMEZONE_DROPDOWN"] = "timezone-dropdown";
    TimezoneSelectionDataHooks["TIMEZONE_TEXT"] = "timezone-text";
})(TimezoneSelectionDataHooks || (TimezoneSelectionDataHooks = {}));
//# sourceMappingURL=TimezoneSelectionDataHooks.js.map